// Calculate dosage for hangover relief formula
export function calculateHangoverDosage(answers) {
    // 菊花 (1-2g) - 清肝明目
    let juhua = 1;

    // 基于饮酒频率
    let weeklyDrinks = 0;
    if (answers.mainConcern === 'regular_drinker') {
        if (answers.drinkingFrequency === 'daily') {
            weeklyDrinks = 7;
        } else if (answers.drinkingFrequency === '4-6_week') {
            weeklyDrinks = 5;
        } else {
            weeklyDrinks = 2.5;
        }
    } else if (answers.mainConcern === 'hangover' && answers.hangoverFrequency === 'weekly') {
        weeklyDrinks = 4;
    } else if (answers.mainConcern === 'reduce') {
        if (answers.currentDrinking === 'daily') {
            weeklyDrinks = 7;
        } else if (answers.currentDrinking === '3-5_week') {
            weeklyDrinks = 4;
        } else {
            weeklyDrinks = 1.5;
        }
    }

    if (weeklyDrinks >= 5) {
        juhua = 2;
    } else if (weeklyDrinks >= 2) {
        juhua = 1.5;
    }

    // 如果容易上火，增加菊花
    if (answers.constitution?.includes('heat')) {
        juhua = Math.min(2, juhua + 0.5);
    }

    // 白茅根 (2-3g) - 清热利尿
    let baimaogen = 2;

    if (answers.mainConcern === 'hangover') {
        // 宿醉症状严重程度
        const symptomCount = answers.hangoverSymptoms?.length || 0;
        const hasSevereSymptoms =
            answers.hangoverSymptoms?.includes('headache') ||
            answers.hangoverSymptoms?.includes('nausea') ||
            answers.hangoverSymptoms?.includes('vertigo');

        if (symptomCount >= 3 || hasSevereSymptoms) {
            baimaogen = 3;
        } else if (symptomCount >= 1) {
            baimaogen = 2.5;
        }

        // 持续时间长也增加剂量
        if (answers.hangoverDuration === 'full_day') {
            baimaogen = 3;
        }
    } else if (weeklyDrinks >= 5) {
        baimaogen = 2.5;
    }

    // 甘草 (1-2g) - 解毒和中
    let gancao = 1;

    // 有肠胃问题
    const hasStomachIssues =
        answers.afterEffects?.includes('stomach') ||
        answers.otherSymptoms?.includes('stomach') ||
        answers.socialConcerns?.includes('stomach');

    if (hasStomachIssues) {
        gancao = 2;
    } else if (weeklyDrinks >= 5 || answers.mainConcern === 'reduce') {
        gancao = 1.5;
    }

    // 计算总剂量等级
    const total = juhua + baimaogen + gancao;
    let level;
    if (total <= 4.5) level = 'light';
    else if (total <= 6) level = 'medium';
    else level = 'heavy';

    return {
        juhua,
        baimaogen,
        gancao,
        level,
        total
    };
}

// Determine review status
export function getHangoverReviewStatus(answers, dosage) {
    // Red flags
    if (answers.safety && !answers.safety.includes('none')) {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Health risk factors detected, professional review required.'
        };
    }

    if (answers.demographics?.age === 'other') {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Age factor requires professional confirmation.'
        };
    }

    // Yellow flags
    if (answers.drinkingFrequency === 'daily') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Daily drinking, priority assessment recommended.'
        };
    }

    if (answers.drinkingAmount === '5+') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'High alcohol consumption, priority assessment recommended.'
        };
    }

    if (answers.liverCheck === 'elevated') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Elevated liver function markers, priority assessment recommended.'
        };
    }

    if (answers.hangoverDuration === 'full_day') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Long duration of hangover symptoms, professional assessment recommended.'
        };
    }

    if (answers.reduceGoal === 'quit' && answers.currentDrinking === 'daily') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Professional guidance recommended for quitting drinking.'
        };
    }

    // Green
    return {
        status: 'green',
        label: 'Auto Approved',
        message: 'Formula generated, proceeding to production.'
    };
}

// Base formula
export const HANGOVER_BASE_FORMULA = [
    { name: 'Kudzu root', amount: '5g' },
    { name: 'Hovenia Dulcis Thunb', amount: '3g' },
    { name: 'Aged tangerine peel', amount: '2g' },
    { name: 'Poria Mushroom', amount: '2g' }
];